import { GetPremiumStatusResult, PremiumStatus } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { createNotifyingQueryFn } from 'store/utils/createNotifyingQueryFn';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';
import { web3Api } from 'store/queries';

export interface IFetchAccountStatusParams {
  userEndpointToken: string;
}

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be refelected there as well.
export const {
  endpoints: { fetchAccountStatus },
  useFetchAccountStatusQuery,
  useLazyFetchAccountStatusQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchAccountStatus: build.query<
      GetPremiumStatusResult,
      IFetchAccountStatusParams
    >({
      queryFn: createNotifyingQueryFn(async ({ userEndpointToken }) => {
        const service = MultiService.getService();

        const data = await service
          .getWorkerGateway()
          .getPremiumStatus(userEndpointToken);

        return { data };
      }),
    }),
  }),
  overrideExisting: true,
});

export const fetchAccountStatusFallback: GetPremiumStatusResult = {
  isEnterprise: false,
  isFreemium: true,
  status: PremiumStatus.INACTIVE,
};

export const {
  selectDataWithFallbackCachedByParams: selectAccountStatus,
  selectInitalLoadingCachedByParams: selectAccountStatusInitialLoading,
  selectLoadingCachedByParams: selectAccountStatusLoading,
  selectStateCachedByParams: selectAccountStatusState,
} = createQuerySelectors({
  endpoint: fetchAccountStatus,
  fallback: fetchAccountStatusFallback,
});
